import { render, staticRenderFns } from "./workerList.vue?vue&type=template&id=2f6b74c4&scoped=true"
import script from "./workerList.vue?vue&type=script&lang=js"
export * from "./workerList.vue?vue&type=script&lang=js"
import style0 from "./workerList.vue?vue&type=style&index=0&id=2f6b74c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b74c4",
  null
  
)

export default component.exports